import moment from 'moment';

export function fromNowFilter() {
  function fromNow(input) {
    return moment(input).fromNow();
  }

  fromNow.$stateful = true;

  return fromNow;
}

export function formatFilter() {
  return function (input, format) {
    if (input) {
      return moment(input).format(format);
    }

    return input;
  };
}

export function endOfFilter() {
  return function (input, format) {
    if (input) {
      return moment(input).endOf(format);
    }

    return input;
  };
}
